// extracted by mini-css-extract-plugin
export default {"container":"DwElD7KNAEag4oLUMoSk","pagination":"LTUqOtHSsA_q7DqPyrio"};